import { CategoryEnum } from '../../enums/category';
import { ListingRequestType } from '../../enums/listing-request-type.enum';
import { Draft } from './draft';
import { MotorsDraft } from './motors.draft';

export interface ListingRequest {
  type: ListingRequestType;
  categoryId: CategoryEnum;
  subCategory?: string;
}

export interface EditListingRequest extends ListingRequest {
  listingId: number;
  draft: Draft;
  listingEndDate: Date;
}

export interface RelistListingRequest extends ListingRequest {
  listingId: number;
  draft: Draft;
}

export interface MotorsEditListingRequest extends ListingRequest {
  listingId: number;
  draft: MotorsDraft;
  listingEndDate: Date;
}

export interface MotorsRelistListingRequest extends ListingRequest {
  listingId: number;
  draft: MotorsDraft;
}
